export default function countyData() {
  return {
    registration: {
      countyWheelTaxDecalNo: null,
      cityWheelTaxDecalNo: null
    }
  };
}
